import { MapPin, ArrowRight, Sparkles } from "lucide-react";
import PlayerInterestDialog from "@/components/site/PlayerInterestDialog";
import { HERO, INTEREST } from "@/constants/testIds";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid={HERO.section}
      className="relative min-h-[100vh] flex items-end overflow-hidden grain"
    >
      <img
        src="https://images.pexels.com/photos/15828942/pexels-photo-15828942.jpeg"
        alt="Spotlight basketball hoop"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-bg-overlay" />

      {/* Coach Sean cutout — only wider desktops (xl+) so headline is never covered */}
      <div className="hidden xl:block absolute right-0 bottom-0 top-24 pointer-events-none w-[38%] 2xl:w-[36%] z-0">
        <div className="relative h-full w-full">
          <img
            src="/brand/coach-sean.png"
            alt="Coach Sean Bledsoe"
            className="absolute right-0 bottom-0 h-[94%] w-auto object-contain object-bottom drop-shadow-[0_30px_60px_rgba(0,0,0,0.75)]"
          />
          {/* Left → transparent fade so coach blends into hero */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#050B14] via-[#050B14]/80 to-transparent" />
          {/* Top fade */}
          <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#050B14] to-transparent" />
          {/* Bottom fade */}
          <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#050B14] to-transparent" />
        </div>
        <div className="absolute right-10 bottom-32 text-right">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#93A5C0]">
            Founder · Program Director
          </div>
          <div className="font-display text-2xl text-white mt-1">
            Coach Sean Bledsoe
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-24 pt-40 w-full">
        <div className="max-w-3xl">
          <img
            src="/brand/bba-logo.png"
            alt="Team BBA Elite Shield"
            className="h-28 sm:h-36 w-auto mb-6 drop-shadow-[0_10px_30px_rgba(0,0,0,0.55)] floaty"
          />
          <div className="flex flex-wrap items-center gap-3 mb-8">
            <div
              data-testid={HERO.locationBadge}
              className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/15 bg-white/5 backdrop-blur-sm"
            >
              <MapPin size={14} className="text-white" />
              <span className="text-xs tracking-[0.22em] uppercase text-white/80">
                Lees Summit, MO · Midwest Elite
              </span>
            </div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-[#B8C5D6]/40 bg-[#B8C5D6]/10 backdrop-blur-sm">
              <Sparkles size={13} className="text-[#B8C5D6]" />
              <span className="text-xs tracking-[0.22em] uppercase text-[#B8C5D6]">
                Full Player Sponsorships Available
              </span>
            </div>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-white">
            When you leave our program,{" "}
            <span className="text-[#B8C5D6]">
              you'll be ready for your next basketball opportunity.
            </span>
          </h1>

          <p className="mt-7 text-base sm:text-lg text-[#A0ABC0] max-w-2xl leading-relaxed">
            Bledsoe Basketball Academy is one of the finest basketball
            development programs in the Midwest. Founded by Sean Bledsoe —
            Former Division 1 Coach and NBA Player Consultant — we maximize
            your strengths and add real, game-tested skill to your game.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <PlayerInterestDialog
              testId={INTEREST.heroTrigger}
              trigger={
                <button
                  type="button"
                  data-testid={HERO.ctaPrimary}
                  className="btn-gold inline-flex items-center gap-2 px-7 py-4 text-sm uppercase"
                >
                  Player Interest
                  <ArrowRight size={16} />
                </button>
              }
            />
            <a
              href="#programs"
              data-testid={HERO.ctaSecondary}
              className="btn-ghost-gold inline-flex items-center gap-2 px-7 py-4 text-sm uppercase"
            >
              Explore Programs
            </a>
          </div>

          <div className="mt-16 grid grid-cols-3 max-w-xl gap-6 border-t border-white/10 pt-8">
            {[
              { k: "D1", v: "Coaching Pedigree" },
              { k: "NBA", v: "Player Consulting" },
              { k: "MW", v: "Midwest Premier" },
            ].map((s) => (
              <div key={s.k}>
                <div className="font-display text-3xl text-[#B8C5D6]">
                  {s.k}
                </div>
                <div className="text-[11px] tracking-[0.22em] uppercase text-white/60 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 hidden md:flex items-center gap-3 text-xs tracking-[0.3em] uppercase text-white/50">
        <span className="w-12 h-px bg-white/40" />
        Scroll
      </div>
    </section>
  );
}
